import type { ReactNode } from 'react';

import styles from './Seg.module.css';

export interface SegOption<T extends string> {
  value: T;
  label: ReactNode;
  disabled?: boolean;
}

export interface SegProps<T extends string> {
  value: T;
  onChange: (next: T) => void;
  options: SegOption<T>[];
  ariaLabel?: string;
  className?: string;
}

export function Seg<T extends string>({
  value,
  onChange,
  options,
  ariaLabel,
  className,
}: SegProps<T>) {
  return (
    <div
      className={[styles.seg, className].filter(Boolean).join(' ')}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={
            value === option.value ? `${styles.item} ${styles.on}` : styles.item
          }
          onClick={() => onChange(option.value)}
          disabled={option.disabled}
          role="tab"
          aria-selected={value === option.value}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
